import { render, staticRenderFns } from "./Familia.vue?vue&type=template&id=510af354"
import script from "./Familia.vue?vue&type=script&lang=js"
export * from "./Familia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports